import { useEffect, useState } from "react";
import { CourtierListItem } from "api/courtiers";
import { useAppSelector } from "app/hooks";
import { GenericLoading } from "components/ui/Loader";
import { selectReferentialData } from "features/referentials/selectors/selectReferentialDataByKey";
import { loadBrokerEditValues } from "../hooks/loadBrokerEditValues";
import { useBrokerForm } from "../hooks/useBrokerForm";
import { BrokerForm } from "./BrokerForm";
import { BrokerFormValues } from "./BrokerFormValues";

interface BrokerEditFormProps {
  broker: CourtierListItem;
  onSuccess?: () => void;
}

/** Side panel content of « Modifier » : loads the broker, then the broker form in edit mode. */
export const BrokerEditForm: React.FC<BrokerEditFormProps> = ({ broker, onSuccess }) => {
  const referentialsData = useAppSelector(selectReferentialData);
  const { updateBroker } = useBrokerForm();
  const [initialValues, setInitialValues] = useState<Partial<BrokerFormValues>>();

  useEffect(() => {
    let isActive = true;
    // Loaded once per opened broker: a referential refresh must not reset the form.
    loadBrokerEditValues(broker, referentialsData).then((values) => {
      if (isActive) setInitialValues(values);
    });
    return () => {
      isActive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [broker]);

  if (!initialValues) {
    return (
      <div className="relative min-h-40">
        <GenericLoading loading isParentSized />
      </div>
    );
  }

  return (
    <BrokerForm
      brokerId={broker.id}
      initialValues={initialValues}
      onSubmit={(values) => updateBroker(broker.id, values)}
      onSuccess={onSuccess}
    />
  );
};
